import axios, { AxiosInstance } from 'axios'
import { getAccessToken } from './auth'
import { APP_RESTHTTPLINK_URI } from './constants'

export class AxiosApiLayer {
  private static instance: AxiosInstance
  private static access_token: string | null

  static getInstance(): AxiosInstance {
    if (
      !AxiosApiLayer.instance ||
      getAccessToken() !== AxiosApiLayer.access_token
    ) {
      AxiosApiLayer.access_token = getAccessToken() //sessionStorage.getItem('token')
      axios.defaults.headers.common[
        'Authorization'
      ] = `Bearer ${AxiosApiLayer.access_token}`

      axios.defaults.headers.common['appcode'] = 'i'

      const instance = axios.create({
        baseURL: APP_RESTHTTPLINK_URI,
      })
      AxiosApiLayer.instance = instance
    }
    return AxiosApiLayer.instance
  }
}
